import { ArrowLeftIcon, FaceSmileIcon } from '@heroicons/react/24/outline';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from '../../../../components/ui/dialog';

interface EnhanceCheckoutDialogProps {
  open: boolean;
  onLinkPayment: () => void;
  onContinueWithout: () => void;
  onBack: () => void;
  onClose: () => void;
}

export function EnhanceCheckoutDialog({
  open,
  onLinkPayment,
  onContinueWithout,
  onBack,
  onClose
}: Readonly<EnhanceCheckoutDialogProps>) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-[25rem] rounded-3xl sm:max-w-[26rem]">
        <DialogHeader>
          <DialogTitle className="sr-only">Enhance Your Checkout</DialogTitle>
        </DialogHeader>

        <div className="flex flex-col items-center px-4 pb-4 pt-2 text-center">
          {/* Icon */}
          <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-[#f0faf5]">
            <FaceSmileIcon className="h-9 w-9 text-[#5CB891]" />
          </div>

          {/* Heading */}
          <h2 className="text-xl font-bold text-gray-900">
            Enhance Your Checkout
          </h2>

          {/* Description */}
          <p className="mt-3 text-sm leading-relaxed text-gray-500">
            Link your payment to enable Face Payment; otherwise, you'll only be
            able to use loyalty checkout.
          </p>

          {/* Actions */}
          <div className="mt-6 flex w-full flex-col gap-3">
            <button
              type="button"
              onClick={onLinkPayment}
              className="w-full rounded-2xl bg-[#5CB891] px-4 py-4 text-sm font-bold uppercase tracking-wide text-white transition-colors hover:bg-[#4aa07c]"
            >
              Link Payment Method
            </button>

            <button
              type="button"
              onClick={onContinueWithout}
              className="w-full rounded-2xl border-2 border-gray-200 px-4 py-4 text-sm font-semibold text-gray-700 transition-colors hover:border-gray-300 hover:bg-gray-50"
            >
              Continue without Payment
            </button>
          </div>

          {/* Back link */}
          <button
            type="button"
            onClick={onBack}
            className="mt-6 flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700"
          >
            <ArrowLeftIcon className="h-4 w-4" />
            <span>Go back to enter Account Details</span>
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
